import React from 'react';
import Styles from './ToggleButtonCopy.module.scss';
import cn from 'classnames';

const ToggleButton = ({ isOn, handleToggle, serverAppTheme }) => {
  return (
    <>
      <input
        checked={isOn}
        onChange={handleToggle}
        className={Styles.reactswitchcheckbox}
        id="react-switch-new"
        type="checkbox"
      />
      <label
        className={cn(Styles.reactswitchlabel, 'mb-0')} style={{background: serverAppTheme?.toggleButton_bg}}
        htmlFor="react-switch-new"
      >
        <span className={Styles.reactswitchbutton} style={{background:serverAppTheme ? serverAppTheme?.secondaryBtn : '#D9D9D9'}}/>
      </label>
    </>
  );
};

export default ToggleButton;
